import MenuIcon from '@mui/icons-material/Menu';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import { makeStyles } from '@mui/styles';
import Menu from './Menu';
import Logo from './Logo';
import { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { useLocation } from 'react-router-dom';
import Banner from '../ListGroups/Banner';
import { DefaultBanner } from '../ListGroups/Banner';
import { BANNER_OVERLAY } from '../designTokens';

const useStyles = makeStyles({
    Banner: {
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "scroll",
        backgroundSize: "cover",
    }
});

const MobileHeader = () => {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const location = useLocation();
    const [bannerObj,setBannerObj] = useState({...DefaultBanner})
    useEffect(()=>{
        setOpen(false);
        if(Banner[location.pathname]){
            setBannerObj({...Banner[location.pathname]});
        }
        else{
            setBannerObj({...DefaultBanner});
        }
    },[location]);
    const ToggleMenu = () => {
        setOpen((prev) => !prev);
    }
    return (
        <>
            <header className="header">
                <Logo />
                <Collapse in={open} timeout="auto">
                    <Menu />
                </Collapse>
                <IconButton onClick={ToggleMenu} style={{
                    position: 'absolute',
                    right: "20px",
                    top: "10px",
                    width: "3rem",
                    height: "3rem",
                }}><MenuIcon style={{
                    width: "3rem",
                    height: "3rem",
                    fontSize: "3rem"
                }} /></IconButton>

            </header>
            <article
                className={classes.Banner}
                style={{
                    marginBottom: "10px",
                    background: bannerObj.solidBackground || !bannerObj.backgroundUrl
                        ? BANNER_OVERLAY
                        : `${BANNER_OVERLAY}, url(${bannerObj.backgroundUrl})`,
                }}
            >
                <Grid container alignItems="center" style={{ height: "100%" }}>
                    <Grid item style={{ margin:'1.5rem'}}>
                        {
                            bannerObj.backgroundDescriptions.map(function(el){
                                return (
                                    <h2 className="text-white mobile-header-banner-text" style={el.style}>{el.text}</h2>
                                );
                            })
                        }
                    </Grid>
                </Grid>
            </article>
        </>
    );
}

export default MobileHeader;